
/*eslint-disable*/
import React from "react";
// react library for routing
import {Link} from "react-router-dom";
// reactstrap components
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Collapse,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Row,
    Container,
    Card,
    CardHeader,
    CardBody,
    ListGroup,
    ListGroupItem,
    Carousel,
    CarouselIndicators,
    CarouselItem,
    CarouselCaption, CarouselControl, Modal, CardTitle, CardText
} from 'reactstrap';
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.jsx";
import IndexHeader from "components/Headers/IndexHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";
import ContentService from "../services/xgContentService";
import _ from "lodash";
import CompaniesCarousel from "./CompaniesCarousel";
import {countries} from "../util/countries";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {services} from "../util/services";
import NotificationAlert from "react-notification-alert";
import {deliveryPeriods} from "../util/deliveryPeriods";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import FormInput from "../components/common/form/FormInput";
import ContactUsService from "../services/contactUsService";
import {Helmet} from "react-helmet";
import CardFooter from "reactstrap/es/CardFooter";
import AppNavBar from "./AppNavBar";
import PricingComponent from "./pricingXaregrowth/PricingComponent";


const data = [
    {
        solution: "Trust Score",
        display: 'block',
        title: "Trust Score",
        description:
            "Convey trust to new B2B customers quicker by leveraging current customer satisfaction levels",
        media :{
            type: 'image',
            url : "images/solutions/ts.png"
        },
        details : [
            {
                key : UtilService.uuidv4(),
                value : ' Mass email a 5 question survey to your current customer base'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Identify trends and track customer sentiment by running periodic surveys'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Use your Trust Score to convey trust quicker and reduce sales cycles'
            },
            {
                key : UtilService.uuidv4(),
                value : ' You decide if you want your Trust Score to be public or not'
            }
        ]
    },


    {
        solution: "Growth Readiness Assessment",
        display: 'block',
        description:
            "Assess your readiness for expanding your business in new international markets and new customer segments",
        media :{
            type: 'image',
            url : 'images/solutions/rsa.png'
        },
        details : [
            {
                key : UtilService.uuidv4(),
                value : ' Free Self Asessment across 6 different categories'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Receive score and recommendations via email'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Third party assessment to get your Readiness Score'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Use your Readiness Score to convey trust to distributors and customers'
            }
        ]
    },
    {
        solution: "My Document Sharing",
        display: 'block',
        description:
            "Make it easy for your partners, clients and sales teams to access up to date sales and marketing material",
        media :{
            type: 'image',
            url : 'images/solutions/mds.png'
        },
        details : [
            {
                key : UtilService.uuidv4(),
                value : ' Allow partners to access all supplier materials from a single portal'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Ensure documents accessed are always up to date'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Control who has access to the material at any given time'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Option: Feed your sales material to our AI Smart Sales engine'
            }
        ]
    },
    {
        solution: "Online Business Development Training (Coming Soon)",
        display: 'block',
        description:
            "Train your teams for more effective Business Development in your domestic and international markets",
        media :{
            type: 'image',
            url : 'images/solutions/ot.png'
        },
        details : [
            {
                key : UtilService.uuidv4(),
                value : ' International Business Development Course'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Account Management Course'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Channel Sales Management Course'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Digital Lead Generation Course'
            }
        ]
    },
    {
        solution: "AI Smart Sales",
        display: 'none',
        description:
            "Boost sales effectiveness and cut down training costs for your sales and after sales teams ",
        media :{
            type: 'image',
            url : 'images/solutions/ai.png'
        },
        details : [
            {
                key : UtilService.uuidv4(),
                value : ' Upload all your documents, videos and audios to our AI engine'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Instant responses to commercial and technical questions'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Channel Sales Management Course'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Use your Readiness Score to convey trust to distributors and customers'
            }
        ]
    },


    {
        solution: "Smart Admin Document Share & Exchange (xarex.co)",
        display: 'block',
        description:
            "Reduce invoice payment delays and costs while cutting down time waste in sales & procurement document processing",
        media :{
            type: 'image',
            url : 'images/solutions/sde.png'
        },
        details : [
            {
                key : UtilService.uuidv4(),
                value : ' Share your documents through a cloud folder rather than email'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Automate invoice payment reminders pre & post due date'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Reduce transaction costs when paying international suppliers'
            },
            {
                key : UtilService.uuidv4(),
                value : ' Protect sensitive information from phishing attacks'
            }
        ]
    },



]

class Solutions  extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: UtilService.uuidv4(),
            loginModal: false,
            contentData: {}
        };
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
    }


    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };



    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        return (
            <div style={{backgroundColor: "white"}}>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <AppNavBar loginModalToggle={this.toggleModal}/>

                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Our Solutions</p>
                                    <h1 style={{textAlign: "start"}}>Enabling Business Growth</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>

                <Container className="mt-10" style={{backgroundColor: "white"}}>
                    <SolutionCards data={data}/>
                </Container>

                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>

                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

const SolutionCards = ({ data }) => {
    return (
        <Container className="my-5">
            <Row>
                {data.map((item, index) => (
                    <>
                        <Col md="12" lg="12" className="mb-4" key={index} style={{ display: item.display }} key={index}>
                            <Card className="h-100 shadow-sm border-0">
                                <CardHeader>
                                    <Row>
                                        <Col md={1}></Col>
                                        <Col md={11}>
                                            <CardTitle tag="h1" style={{marginBottom: 'initial',
                                                borderBottom: '4px solid red',
                                                display: 'inline-block', // required for underline to size correctly
                                                paddingBottom: '0px',// optional spacing
                                            }}>{item.solution}</CardTitle>

                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={1}></Col>
                                        <Col md={4}>
                                            <div style={{
                                                height: '300px',
                                                width: '100%',
                                                overflow: 'hidden',
                                                background: 'white',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                marginLeft: '-12px'
                                            }}>
                                                <img
                                                    src={item.media.url}
                                                    alt={item.solution}
                                                    style={{
                                                        height: '100%',
                                                        width: '100%',
                                                        objectFit: 'contain'
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={7} style={{paddingLeft: '20px'}}>
                                            <CardTitle tag="h4" className="fw-bold">{item.description}</CardTitle>
                                            <ul className="ps-3">
                                                {item.details.map(detail => (
                                                    <li key={detail.key} className="mb-1"><CardText>{detail.value}</CardText></li>
                                                ))}
                                            </ul>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                        <PricingComponent showChart={"none"} display={item.display}  />
                    </>
                ))}
            </Row>
        </Container>
    );
};

export default Solutions;
